import { Component, OnInit, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { OnboardingService } from '../onboarding.service';

@Component({
  selector: 'app-email-code-validation',
  templateUrl: './email-code-validation.component.html',
})
export class EmailCodeValidationComponent implements OnInit {
  router = inject(Router);
  onboardingService = inject(OnboardingService);
  auth = inject(AuthService);
  _snackBar = inject(MatSnackBar);

  validationCode!: string;
  errorCode = false;

  canResend = false;
  countdown = 30;
  interval: any;

  ngOnInit(): void {
    if (!this.onboardingService.username) {
      this.router.navigate(['/onboarding/login'], { replaceUrl: true });
    }
    this.startCountdown();
  }

  startCountdown() {
    this.canResend = false;
    this.countdown = 30;
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.canResend = true;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  async resendCode() {
    if (!this.canResend) return;
    this.startCountdown();
    try {
      await this.auth.resendSignUp(this.onboardingService.username);
      this._snackBar.open('El código fue enviado', 'Cerrar', { duration: 5000 });
    } catch (err) {
      console.error(err);
      this._snackBar.open('Error enviando código', 'Cerrar', { duration: 5000 });
    }
  }

  async validate() {
    if (!this.validationCode) return;
    this.errorCode = false;
    try {
      await this.auth.confirmSignUp(this.onboardingService.username, this.validationCode);
      this.router.navigate(['/onboarding/login'], { replaceUrl: true });
    } catch (e: any) {
      console.error(e);
      this.errorCode = true;
    }
  }
}
